<template>
<span>
    
</span>
</template>

<script>
import axios from 'axios';

export default {
    name: 'mainContent',
    data(){
        return{
            main_content:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN            
        };        
    },
    components:{
       
    },
    created :function(){
        this.showContent()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'showContent'
    },
	methods:{
      showContent(){
            
        this.$emit('content_ld_flag_false')
        var module_id=this.$route.params.module_id
          axios.get(this.$store.state.apiUrl+'/module_details',{
              params:{
                  id_module:'m'+module_id,
                  id_language:this.$store.state.companyData['id_language'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_country:this.$store.state.companyData['id_country'], 
                  id_eap:this.$store.state.companyData['id_eap']                  
              }
          })
          .then(response => {
                response = response.data
                //console.log(response);
                this.main_content = response;
                this.$emit('content_ld_flag_changed');               
                this.$nextTick(function () {
                })
              
          })
          .catch((error) => {
                this.main_content = [];
                this.customErrorHandler(error.response.status);
          });
      }

    }
};
</script>
<style scoped>


</style>
